import { render, staticRenderFns } from "./Продажи по импорт.vue?vue&type=template&id=16332314&scoped=true"
import script from "./Продажи по импорт.vue?vue&type=script&lang=js"
export * from "./Продажи по импорт.vue?vue&type=script&lang=js"
import style0 from "./Продажи по импорт.vue?vue&type=style&index=0&id=16332314&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16332314",
  null
  
)

export default component.exports